module.exports = {
    isIOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
    },
    getBodyScrollTop: function() {
        return (
            self.pageYOffset ||
            (document.documentElement && document.documentElement.scrollTop) ||
            (document.body && document.body.scrollTop)
        );
    },
    getBodyMiddlePos: function() {
        return this.getBodyScrollTop() + document.documentElement.clientHeight * 0.5;
    },
    //узнать настоящую полную высоту блока с заданным max-height
    getTrueHeight: function($block) {
        var el = $block
            .clone()
            .css({
                height: 'auto',
                width: $block.width(),
                overflow: 'hidden',
                'max-height': 'none'
            })
            .insertAfter($block);

        var trueHeight = el.outerHeight(true);
        el.remove();

        return trueHeight;
    },
    number_format: require('locutus/php/strings/number_format'),

    setMaskedPhone: function($element) {
        $element.mask('+7(999)999-99-99', { autoclear: false });
    },
    setMaskedPhoneCity: function($element) {
        $element.mask('+7(999)999-99-99 (городской)', { autoclear: false });
    },
    setMaskedPhoneMobile: function($element) {
        $element.mask('+7(999)999-99-99 (мобильный)', { autoclear: false });
    },

    getCookie: function(name) {
        let matches = document.cookie.match(
            '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    setCookie : function (name, value, options) {
        options = options || {}

        var expires = options.expires

        if (typeof expires == 'number' && expires) {
            var d = new Date()
            d.setTime(d.getTime() + expires * 1000)
            expires = options.expires = d
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString()
        }

        value = encodeURIComponent(value)

        var updatedCookie = name + '=' + value

        for (var propName in options) {
            updatedCookie += '; ' + propName
            var propValue = options[propName]
            if (propValue !== true) {
                updatedCookie += '=' + propValue
            }
        }

        document.cookie = updatedCookie
    },
    deleteCookie: function(name)
    {
        let cookie_date = new Date();
        cookie_date.setTime(cookie_date.getTime() - 1);
        document.cookie = name += "=; expires=" + cookie_date.toGMTString();
    }
};
let initDadata = () =>{
    const streetInput = document.getElementById("street");
    const cityInput = document.getElementById("city").value;
    const token = 'b574f61916aa7f16b0ed0aaa318da372bfe05254';
    const type = 'address';
    const {createSuggestions} = window.Dadata;
    const regionSuggestions = createSuggestions(
        streetInput,
        {
            token,
            type: 'address',
            hint: false,
            count: 15,
            params: {
                from_bound: { value: 'street' },
                to_bound: { value: 'street' },
                locations: {
                    city: cityInput
                },
                language: 'ru', // Язык результатов
                strict: true // Строгий поиск по точному совпадению
            }
        }
    );
    const citySuggestions = createSuggestions(
        '',
        {
            token,
            type,
            hint: false,
            params: {from_bound: {value: "city"}, to_bound: {value: "settlement"}}
        },
        regionSuggestions
    );
}



// WEBPACK FOOTER //
// ./modules/functions.js